// extracted by mini-css-extract-plugin
export var cardEmptySection = "compare-product-card-module--cardEmptySection--LUJqf";
export var cardSections = "compare-product-card-module--cardSections--XV0Kk";